module.exports = __webpack_public_path__ + "img/icons_flex.16eaa2ed.svg";